import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class MultiBuyerRedirectGuard implements CanActivate {
  constructor(readonly auth: AuthService, readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const userRole = this.auth.user?.buyerAcssLvls;
    const url = route.routeConfig?.path;

    if (userRole !== 'multiBuyer') {
      return true;
    }

    switch (url) {
      case 'manage-suppliers':
      case 'manage-buyer-settings':
        return this.router.parseUrl('/access-denied');
      default:
        return true;
    }
  }
}
